import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Container,
  Input,
  Label,
  Button,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup
} from 'reactstrap';
import { connect } from 'react-redux';
import { ICommissionBulletinTable, ICommissionBulletinTableRedux } from '../../types/interfaces';

import { getSocietes } from '../../flux/actions/societeActions';
import { getFormula_societe_defaults } from '../../flux/actions/formulasocietedefaultActions';
import TableContainer from "../tables_manager/TableContainer"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faDownload, faExpandArrowsAlt, faExternalLinkAlt, faEye, faFileInvoice, faMoneyCheck, faPlus, faPrint, faRedo, faSpinner, faUndo, faUserEdit } from '@fortawesome/free-solid-svg-icons'
import moment from "moment";
import { useHistory } from 'react-router-dom';
import { useAlert } from "react-alert";

import { DateRangeColumnFilter, NumberRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import Loading from '../Loading';
import PDFLink from '../pdf/PDFLink';
import Select from 'react-select';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';
import { E_ERROR } from '../../types/errors';
import { formulaTagsExp, getAvailableVarsComm, getCommissionType, getEncStatut } from "../../services/misc";
import { betterTypeName } from '../../services/formatting';
import { PRIVILEGE } from '../../types/privileges';
import { constants } from '../../types/constants';

const BulletinTable = ({ 
  linesData,
  formula_societe_default,
  getFormula_societe_defaults,
  societe,
  getSocietes,
  auth
 }: ICommissionBulletinTable) => {
  const history = useHistory();
  const alert = useAlert();
  const { societes, loading: loadingS } = societe;
  const { formula_societe_defaults, loading: loadingFSD } = formula_societe_default;
  const [modalFormula, setModalFormula] = useState(false);
  const [formattedFormula, setFormattedFormula] = useState<any>('');
  
  const handleToggleFormula = () => setModalFormula(!modalFormula);

  useEffect(() => {
    getFormula_societe_defaults();
  }, [getFormula_societe_defaults])

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []);
  }, [getSocietes, auth]);

  const formulaTags = formulaTagsExp.map(e => ({
    ...e,
    tag: <div className="cardSticker" style={{backgroundColor: e.color, margin: 0, marginLeft: "4px"}} 
    // onMouseOver={() => setHighlightTag(e.id)} onMouseOut={() => setHighlightTag(undefined)}
    >{e.name}</div>
  }));

  const formatFormula = e => {
    const availableVars = getAvailableVarsComm(e)
    return {
      id: e.id,
      name: e.name,
      content: <div className="formulaTagsContainer">
        {availableVars.map((t, key, arr) => <>
          <div className="formulaTagsEach">{t.o === 'p' ? <div><b style={t.n < 0 ? {color: "darkred"} : {}}>{t.n}%</b> ×</div> : <div><b style={t.n < 0 ? {color: "darkred"} : {}}>{t.n.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH</b> pour chaque</div>}{formulaTags.find(e => e.id === t.v)?.tag || null}</div>
          {!!(key < arr.length - 1) && <FontAwesomeIcon icon={faPlus} className="formulaTagsPlus" />}
        </>)}
      </div>
    }
  }

  const columns = useMemo(() => [
    {
      Header: "Commission",
      accessor: "commission",
      Filter: NumberRangeColumnFilter,
      filter: 'between',
      className: "text-center",
      Footer: e => {
        const total = useMemo(
          () =>
            e.rows.reduce((e, row) => e + (row.values.commission || 0), 0),
          [e.rows]
        )

        // return <div style={{textAlign: "right", fontWeight: 600, fontSize: "large"}}><span>Total:</span>&nbsp;<span style={{color: total > 0 ? "green" : "red"}}>{total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh</span></div>
        return <div style={{display: "flex", justifyContent: "space-between"}}>
          <div>Total: </div>
          <div style={{textAlign: "right", fontWeight: 600, fontSize: "large", color: total > 0 ? "green" : "red"}}>{total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>
        </div>
      },
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? <div className="cardSticker" style={{textAlign: "center", color: "white", backgroundColor: value > 0 ? "darkgreen" : "darkred"}}>{value > 0 && "+"}{value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div> : "-"
    },
    {
      Header: "Bonus/Malus",
      accessor: "bonus_malus",
      filter: 'equals',
      className: "text-center",
      Footer: e => {
        const total = useMemo(
          () =>
            e.rows.reduce((e, row) => e + (row.values.bonus_malus || 0), 0),
          [e.rows]
        )

        // return <div style={{textAlign: "right", fontWeight: 600, fontSize: "large"}}><span>Total:</span>&nbsp;<span style={{color: total > 0 ? "green" : "red"}}>{total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh</span></div>
        return <div style={{display: "flex", justifyContent: "space-between"}}>
          <div>Total B/M: </div>
          <div style={{textAlign: "right", fontWeight: 600, fontSize: "large", color: total > 0 ? "green" : "red"}}>{total.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div>
        </div>
      },
      // filter: (rows, id, e) => rows.filter(t => Number(((+t.original[id]) || 0).toFixed(4)).toString().includes((e || "").replace(",", "."))),
      Cell: ({ value }) => value ? <div style={{color: value > 0 ? "darkgreen" : "darkred"}}>{value > 0 && "+"}{value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</div> : "-",
    },
    {
      Header: "Fiche Vente",
      className: "text-center",
      disableSortBy: true,
      disableFilters: true,
      Cell: ({ row: {original} }) => (
          <div className="actionsContainer">
              {original.commission_history?.venteId ? <PDFLink documentType={"vente"}
                func={async () => getVenteByIdPromise(original.commission_history.venteId || -1)}
                download={false}
                buttonText=""
                iconSize="inherit"
                // customClassNames="btn btn-info"
                customButtonIcon={faFileInvoice}
                allowPrintPreview={true}
                htmlTitle={`Voir la fiche de Vente`}
                customClassNames="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light"//actionButtonsSpace
                style={{paddingRight: ".75rem", paddingLeft: ".75rem"}} /> : null}
          </div>
      ),
    },
    {
      Header: "Source",
      id: "Source",
      accessor: e => getCommissionType(e.commission_history?.type),
      customExportDisplay: `getCommissionTypeHandle($.commission_history && $.commission_history.type)`,
      // accessor: row => row.commission_history?.type === "V" ? "Vente" : row.commission_history?.type === "A" ? "Association" : row.commission_history?.type === "E" ? "Encaissement non récep." : row.commission_history?.type === "ER" ? "Encaissement réceptionné" : row.commission_history?.type === "EEI" ? "Encaissement à verser" : row.commission_history?.type === "EEncaisse" ? "Encaissement encaissé" : row.commission_history?.type === "EImpaye" ? "Encaissement impayé" : (row.commission_history?.type || ""),
      // customExportDisplay: `$.commission_history ? $.commission_history.type === "V" ? "Vente" : $.commission_history.type === "A" ? "Association" : $.commission_history.type === "E" ? "Encaissement non récep." : $.commission_history.type === "ER" ? "Encaissement réceptionné" : $.commission_history.type === "EEI" ? "Encaissement à verser" : $.commission_history.type === "EEncaisse" ? "Encaissement encaissé" : $.commission_history.type === "EImpaye" ? "Encaissement impayé" : ($.commission_history.type || "") : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => <b>{value || "-"}</b>
    },
    {
      Header: "ID",
      accessor: "id",
      hidden: true
    },
    {
      Header: "ID CH",
      accessor: "commissionHistoryId",
      hidden: true
    },
    {
      Header: "ID Bien",
      id: "ID Bien",
      accessor: row => row.commission_history?.bienId || "",
      customExportDisplay: `$.commission_history ? $.commission_history.bienId : ""`,
      hidden: true
    },
    {
      Header: "ID Vente",
      id: "ID Vente",
      accessor: row => row.commission_history?.venteId || "",
      customExportDisplay: `$.commission_history ? $.commission_history.venteId : ""`,
      hidden: true
    },
    {
      Header: "ID Association",
      id: "ID Association",
      accessor: row => row.commission_history?.associationId || "",
      customExportDisplay: `$.commission_history ? $.commission_history.associationId : ""`,
      hidden: true
    },
    {
      Header: "ID Encaissement",
      id: "ID Encaissement",
      accessor: row => row.commission_history?.encaissementId || "",
      customExportDisplay: `$.commission_history ? $.commission_history.encaissementId : ""`,
      hidden: true
    },
    {
      Header: "Projet",
      id: "Projet",
      accessor: (row, index) => row.commission_history?.societe?.LIBELE || "",
      customExportDisplay: `($.commission_history && $.commission_history.societe && $.commission_history.societe.LIBELE ? $.commission_history.societe.LIBELE : undefined) || "-"`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      className: "text-center",
      Cell: ({ value, row: {original} }) => value || "-"
    },
    {
      Header: "N° Doss.",
      id: "N° Doss.",
      accessor: e => e.commission_history?.contrat?.NUM_DOSS ? (!isNaN(e.commission_history?.contrat?.NUM_DOSS) ? Number(e.commission_history?.contrat?.NUM_DOSS) : e.commission_history?.contrat?.NUM_DOSS) : "",
      // filter: (rows, id, e) => rows.filter(t => (t.original.contrat_encaissements?.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-") || []).includes(e)),
      // filter: (rows, id, e) => rows.filter(t => t.original.commission_history?.contrat?.NUM_DOSS === e),
      // customExportDisplay: `($.contrat_encaissements && $.contrat_encaissements.length) ? $.contrat_encaissements.filter((e, index, self) => self.findIndex(t => (t.contrat ? t.contrat.id : undefined) === (e.contrat ? e.contrat.id : undefined)) === index).map(t => t.contrat && t.contrat.NUM_DOSS ? t.contrat.NUM_DOSS : "-").join(" / ") : "-"`,
      customExportDisplay: `$.commission_history && $.commission_history.contrat && $.commission_history.contrat.NUM_DOSS ? $.commission_history.contrat.NUM_DOSS : "-"`,
      // Cell: ({ row: {original} }) => original.contrat_encaissements?.length ? original.contrat_encaissements.filter((e, index, self) => self.findIndex(t => t.contrat?.id === e.contrat?.id) === index).map(e => e.contrat?.NUM_DOSS || "-").join(" et ") : "-",
      Cell: ({ row: {original} }) => {
        return original.commission_history?.contrat ? <a href={original.commission_history.contrat?.id !== null && original.commission_history.contrat?.id !== undefined ? (`/consultation/${original.commission_history.contrat.id}`) : '/#'} onClick={(e) => {
          e.preventDefault();
          if(original.commission_history.contrat?.id !== null && original.commission_history.contrat?.id !== undefined)
            window.open('/consultation/' + original.commission_history.contrat.id,'_blank')
          else
            alert.error(E_ERROR.NO_VENTE_WITH_THIS_ID)
        }}><button className="openLinkBtn">{original.commission_history?.contrat?.NUM_DOSS || "-"}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a> : "-"
      }
    },
    {
      Header: "Désignation",
      id: "Désignation",
      accessor: row => `${row.commission_history?.bien?.DESIGNATION || ""}${row.commission_history?.associationId ? row.commission_history?.association ? ` (${row.commission_history?.association.ETAGE === "0" ? "RDC" : `Étage ${row.commission_history?.association?.ETAGE || "-"}`} ${row.commission_history?.association?.POURCENTAGE}%${row.commission_history?.association?.POSITION ? ` ${row.commission_history?.association?.POSITION}` : ""})` : "-Asso-" : ""}`,
      customExportDisplay: `($.commission_history && $.commission_history.bien && $.commission_history.bien.DESIGNATION ? $.commission_history.bien.DESIGNATION : "") + ($.commission_history && $.commission_history.associationId ? $.commission_history.association ? (" (" + ($.commission_history.association.ETAGE === "0" ? "RDC" : ("Étage " + ($.commission_history.association.ETAGE || "-"))) + " " + $.commission_history.association.POURCENTAGE + "%" + ($.commission_history.association.POSITION ? (" " + $.commission_history.association.POSITION) : "") + ")") : "-Asso-" : "")`,
      // customExportDisplay: `$.isAssLine ? (($.ETAGE === "0" ? "RDC" : "Étage " + ($.ETAGE ? $.ETAGE : "-")) + " " + $.POURCENTAGE + "%" + ($.POSITION ? (" " + $.POSITION) : "")) : $.DESIGNATION`,
      // accessor: "DESIGNATION",
    },
    // {
    //   Header: "Type",
    //   accessor: row => row.bien?.TYPE?.toLowerCase().includes("app") ? "Appartement" : row.bien?.TYPE?.toLowerCase().includes("mag") ? "Magasin" : (row.bien?.TYPE || ""),
    //   customExportDisplay: `$.bien && $.bien.TYPE ? $.bien.TYPE : "-"`,
    //   Cell: ({ value }) => value || "-"
    // },
    {
      Header: "Type Bien",
      id: "Type Bien",
      accessor: row => row.commission_history?.typeVente || "",
      customExportDisplay: `$.commission_history ? $.commission_history.typeVente : ""`,
      Cell: ({ value }) => value || "-",
      hidden: true
    },
    {
      Header: "Réf. Règlement",
      id: "Réf. Règlement",
      accessor: row => row.commission_history?.encaissement?.REF_REGLEMENT || "",
      customExportDisplay: `$.commission_history && $.commission_history.encaissement && $.commission_history.encaissement.REF_REGLEMENT ? $.commission_history.encaissement.REF_REGLEMENT : "-"`,
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Montant encaissé",
      id: "Montant encaissé",
      accessor: row => row.commission_history?.encaissement?.MONTANT,
      customExportDisplay: `$.commission_history && $.commission_history.encaissement && $.commission_history.encaissement.MONTANT ? $.commission_history.encaissement.MONTANT : "-"`,
      filter: 'equals',
      Cell: ({ value }) => (value !== null && value !== undefined && value != "") ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
    },
    {
      Header: "Chargé du Bien",
      id: "Chargé du Bien",
      accessor: row => row.commission_history?.contrat?.chargeBienUser?.LOGIN || "",
      customExportDisplay: `$.commission_history && $.commission_history.contrat && $.commission_history.contrat.chargeBienUser ? $.commission_history.contrat.chargeBienUser.LOGIN : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ value }) => value || "-",
    },
    ...(!!auth?.user?.privileges?.includes(PRIVILEGE.SEE_COMMISSIONS_FORMULAS)  ? [{
      Header: "Méthode de calcul",
      // id: "Méthode de calcul",
      accessor: e => e.commission_history?.formulaId || "",
      // customExportDisplay: `$.commission_history ? $.commission_history.formulaId : ""`,
      Filter: SelectColumnFilter,
      filter: 'equals',
      Cell: ({ row: {original} }) => {
        return (<div style={{minWidth: "120px", position: "relative"}}>
          {/* {value} */}
          <div className="selectableList selectableListMini">
            {(!!original.commission_history?.formula && !!formatFormula(original.commission_history?.formula)) && <div className="selectableListItemNoAni">
              {/* <div className="selectableListHead fullFlexCenter" style={{borderRight: "1px solid #eee", lineHeight: "100%"}}><FontAwesomeIcon icon={faEye} /></div> */}
              <div className="selectableListContent"><div className="selectableListContentDiv">{ formatFormula(original.commission_history.formula).content }</div></div>
              {!!formatFormula(original.commission_history.formula).name && <div className="cardSticker selectableListFloatingTitle" title={formatFormula(original.commission_history.formula).name}>{formatFormula(original.commission_history.formula).name}</div>}
              {!!formula_societe_defaults?.find(t => t.formulaId === formatFormula(original.commission_history.formula).id) && <div className="cardSticker selectableListFloatingTitle" style={{backgroundColor: "green", right: "10px", left: "unset", maxWidth: "50%"}} title={`Standard ${formula_societe_defaults.filter(t => t.formulaId === formatFormula(original.commission_history.formula).id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}>{`Standard ${formula_societe_defaults.filter(t => t.formulaId === formatFormula(original.commission_history.formula).id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}</div>}
            </div>}
          </div>
          {!!original.commission_history?.formulaId && <div className="formulaTableId" style={{backgroundColor: constants.formulaIdColors[(original.commission_history?.formulaId - 1) % constants.formulaIdColors.length]}}>{original.commission_history?.formulaId}</div>}
          <FontAwesomeIcon icon={faExpandArrowsAlt} className="formulaZoom" title="Agrandir" onClick={() => {
            setModalFormula(true);
            if(original.commission_history?.formula)
              setFormattedFormula(formatFormula(original.commission_history.formula));
          }} />
        </div>)
      }
    }] : []),
    {
      Header: "Saisie le",
      accessor: "createdAt",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
      customExportDisplay: `$.createdAt ? new Date($.createdAt) : "-"`,
      Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
          sameDay: '[Aujourd\'hui à] HH:mm',
          nextDay: 'DD/MM/YYYY à HH:mm',
          nextWeek: 'DD/MM/YYYY à HH:mm',
          lastDay: '[Hier à] HH:mm',
          lastWeek: 'DD/MM/YYYY à HH:mm',
          sameElse: 'DD/MM/YYYY à HH:mm'
      })}</div> : "-",
      hidden: true
    },
  ], [auth?.user?.privileges]);

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} dataName="commissions" enableCheckBox={false} showFooter />
      </Container>
      <Modal isOpen={modalFormula} toggle={handleToggleFormula}>
        <ModalHeader toggle={handleToggleFormula}>{formattedFormula?.name ? `"${formattedFormula?.name}"` : ""}</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer" style={{padding: 0}}>
            <div className="selectableList">
              {!!formattedFormula && <div className="selectableListItemNoAni">
                <div className="selectableListHead fullFlexCenter" style={{borderRight: "1px solid #eee", lineHeight: "100%"}}><FontAwesomeIcon icon={faEye} /></div>
                <div className="selectableListContent"><div className="selectableListContentDiv">{ formattedFormula.content }</div></div>
                {!!formattedFormula.name && <div className="cardSticker selectableListFloatingTitle" title={formattedFormula.name}>{formattedFormula.name}</div>}
                {!!formula_societe_defaults?.find(t => t.formulaId === formattedFormula.id) && <div className="cardSticker selectableListFloatingTitle" style={{backgroundColor: "green", right: "10px", left: "unset", maxWidth: "50%"}} title={`Standard ${formula_societe_defaults.filter(t => t.formulaId === formattedFormula.id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}>{`Standard ${formula_societe_defaults.filter(t => t.formulaId === formattedFormula.id).filter(t => !!societes?.find(n => n.id === t.societeId)).map(t => societes?.find(n => n.id === t.societeId)?.LIBELE || "").join(" - ")}`}</div>}
              </div>}
            </div>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: ICommissionBulletinTableRedux) => ({
  formula_societe_default: state.formula_societe_default,
  societe: state.societe,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getSocietes, getFormula_societe_defaults })(BulletinTable);
